import { useEffect, useRef } from 'react';

import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import lottie from 'lottie-web';
import logoAnimation from '@assets/lotties/lula-blue-logo.json';

const useStyles = makeStyles<any>()({
  logoContainer: {
    margin: '0 auto',
    justifyContent: 'center !important',
    overflow: 'hidden',
    scale: '1',
    maxHeight: '210px !important',
    minHeight: '210px !important',
    height: '210px !important',
    width: '250px',
  },
});

const animateLogo = (element: Element) => {
  lottie.loadAnimation({
    container: element,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: logoAnimation,
  });
};

export function OverallLoading() {
  const { classes } = useStyles(null);
  const animatedLogoContainerRef = useRef(null);

  useEffect(() => {
    if (animatedLogoContainerRef.current) {
      setTimeout(() => {
        // @ts-ignore
        animateLogo(animatedLogoContainerRef.current);
      }, 1000);
    }
  }, []);

  return (
    <>
      <Box display="flex" flexGrow={1} justifyContent="center">
        <Box display="flex" flexDirection="column">
          <Box display="flex" justifyContent="center" p={2}>
            <div
              ref={animatedLogoContainerRef}
              className={classes.logoContainer}
            />
          </Box>
          <Box display="flex" justifyContent="center" p={2}>
            <Typography variant="h6">
              We&apos;re gathering the customer&apos;s data
            </Typography>
          </Box>
          <Box display="flex" justifyContent="center" p={2}>
            <Typography variant="body2">
              This could take a few moments...
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
